import { isValidElementType } from 'react-is';

/**
 * Wraps parametrized HOC function allowing to call it both with param, or without it, as follows:
 * - HOC(params)(WrappedComponent)
 * - HOC(WrappedComponents)
 */

export var allowParamOmit = function allowParamOmit(HOC) {
  return function (arg) {
    return isValidElementType(arg) ? HOC()(arg) : HOC(arg);
  };
};